import { render, staticRenderFns } from "./location-field.vue?vue&type=template&id=2841e679"
import script from "./location-field.vue?vue&type=script&lang=js"
export * from "./location-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports